<template>
    <div class="row">
        <label for="" class="col-sm-5 col-form-label">
            {{questionLabel}}
            <span class="required-star" v-if="+question.field_required">*</span>
            <i v-if="question.info.length" class="fa fa-info-circle fa-lg" data-toggle="tooltip" data-placement="top"
               :title="question.info"></i>
        </label>
        <div class="col-sm-7">
            <div class="form-group field-holder">
                <input v-on:keyup="showJobSuggestions(answer.value)"
                       v-on:keydown.enter.prevent=""
                       autocomplete="off"
                       :type="question.field_type"
                       class="form-control "
                       v-bind:class="{ 'is-invalid': hasError }"
                       :placeholder="question.field_placeholder"
                       v-model="answer.value">
                <i v-if="isLoading" class="fa fa-refresh fa-spin"></i>
                <ul class="suggestions" v-if="suggestions.length">
                    <li v-on:click="onSuggestionClick(suggestion)" v-bind:key="key"
                        v-for="(suggestion, key) in suggestions">{{suggestion.key}}
                    </li>
                </ul>
                <div v-if="hasError && answer.value ===''" class="invalid-feedback">Dit veld is verplicht</div>
                <div v-if="hasError && answer.value !==''" class="invalid-feedback">Vul een geldige functienaam in (kies een optie uit de dropdown)</div>
            </div>
        </div>
    </div>
</template>

<script>
  import _ from 'underscore'
  import JobService from '../../../services/JobService'
  import store from '../../../store'

  export default {
    name: 'FunctionNameField',

    props: ['question', 'hasError', 'answer', 'questionLabel'],
    data () {
      return {
        suggestions: [],
        isLoading: false,
      }
    },
    methods: {
      onSuggestionClick (suggestion) {
        this.answer.value = suggestion.key
        this.suggestions = []
      },

      showJobSuggestions: _.debounce(function (value) {
        if (value.length > 2) {
          this.isLoading = true
          JobService.getJobNameSuggestions(value)
            .then((result) => {
              this.isLoading = false
              this.suggestions = result.body.suggestions
              if (this.suggestions.length) {
                _.each(this.suggestions, (functionName) => {
                  store.commit('question/addPossibleFunctionNames', functionName.key.toLowerCase())
                })
              }
            })
            .catch(() => {
              this.isLoading = false
            })
        }
      }, 500)
    },
  }
</script>

<style lang="scss" scoped>
    .field-holder {
        position: relative;
    }

    .suggestions {
        position: absolute;
        margin-top: 1px;
        background-color: white;
        border: 1px solid #ced4da;
        z-index: 9999;
        width: 100%;
        padding: 0;
        overflow: hidden;
        border-radius: 2px;
        box-shadow: 3px 4px 7px 0px rgba(0, 0, 0, .3);
        overflow-y: auto;
        height:180px;

        li {
            display: block;
            color: black;
            padding: 5px;
            margin: 0;
            border-bottom: 1px solid #ced4da;
            cursor: pointer;
            height:35px;

            &:last-child {
                border: none;
            }

            &:hover {
                background-color: rgba(20, 130, 181, 0.73);
                color: #fff;
            }
        }
    }

    .fa.fa-spin {
        position: absolute;
        right: 10px;
        top: 12px;
        color: #c3c3c3;
    }
</style>

